import { __extends } from "tslib";
import { isEqual, isNil } from '@antv/util';
import Action from '../base';
// 判断是否有样式
function hasClass(dom, className) {
    if (!dom) {
        return false;
    }
    var cls = '';
    if (!dom.className) {
        return false;
    }
    if (!isNil(dom.className.baseVal)) {
        cls = dom.className.baseVal;
    }
    else {
        cls = dom.className;
    }
    return cls.includes(className);
}
function isParent(dom, cls) {
    var parent = dom.parentNode;
    var rst = false;
    while (parent && parent !== document.body) {
        if (hasClass(parent, cls)) {
            rst = true;
            break;
        }
        parent = parent.parentNode;
    }
    return rst;
}
/**
 * Tooltip 展示隐藏的 Action
 * @ignore
 */
var TooltipAction = /** @class */ (function (_super) {
    __extends(TooltipAction, _super);
    function TooltipAction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeStamp = 0;
        return _this;
    }
    /**
     * 显示 Tooltip
     * @returns
     */
    TooltipAction.prototype.show = function () {
        var context = this.context;
        var ev = context.event;
        var view = context.view;
        var isTooltipLocked = view.isTooltipLocked();
        if (isTooltipLocked) {
            // 锁定时不移动 tooltip
            return;
        }
        var lastTimeStamp = this.timeStamp;
        var timeStamp = +new Date();
        if (timeStamp - lastTimeStamp > 16) {
            var preLoc = this.location;
            var curLoc = { x: ev.x, y: ev.y };
            if (!preLoc || !isEqual(preLoc, curLoc)) {
                this.showTooltip(view, curLoc);
            }
            this.timeStamp = timeStamp;
            this.location = curLoc;
        }
    };
    /**
     * 隐藏 Tooltip。
     * @returns
     */
    TooltipAction.prototype.hide = function () {
        var view = this.context.view;
        var isTooltipLocked = view.isTooltipLocked();
        if (isTooltipLocked) {
            // 锁定 tooltip 时不隐藏
            return;
        }
        this.hideTooltip(view);
        this.location = null;
    };
    TooltipAction.prototype.showTooltip = function (view, point) {
        // 相同位置不重复展示
        view.showTooltip(point);
    };
    TooltipAction.prototype.hideTooltip = function (view) {
        view.hideTooltip();
    };
    return TooltipAction;
}(Action));
export default TooltipAction;
//# sourceMappingURL=tooltip.js.map